/**
 * 文本截断方法，超过指定长度则显示省略号
 * @param {string} text - 需要截断的文本
 * @param {number} maxLength - 最大长度
 * @returns {string} - 处理后的文本
 */
export function localTruncateTextFunction(text, maxLength) {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
